import React, { useState, useEffect } from 'react';
import {config} from "../../shared/config.js";
import * as util from '../../shared/commons.js';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../../shared/ShowError.jsx';
import Laoding from '../../shared/Laoding.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../../shared/GeneralDialogFooter.jsx';
import ShowConfirm from '../../shared/ShowConfirm.jsx';
import Table from 'react-bootstrap/Table';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import { InputText } from 'primereact/inputtext';
import CityCombo from '../../combos/CityCombo.jsx';
import { FloatLabel } from 'primereact/floatlabel';
import FaDate from '../../shared/FaDate.jsx';
import { InputNumber } from 'primereact/inputnumber';
import UserTypeCombo from '../../combos/UserTypeCombo.jsx';
import { InputTextarea } from 'primereact/inputtextarea';

var editedModules = [];
var editedParameters = {};
export default function ServiceList(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [services, setServices] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [serviceId, setServiceId] = useState("");
    const [serviceIndex, setServiceIndex] = useState(-1);
    const [tafsilId, setTafsilId] = useState(0);
    const [title, setTitle] = useState("");
    const [enName, setEnName] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [longDescription, setLongDescription] = useState("");
    const [basePrice, setBasePrice] = useState(0);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = function(){
        setLoading(true);
        var params = {
            login:util.getLoginDto(),
            param1:"0", 
            param2:"0", 
            param3:"0", 
            param4:"0", 
            param5:"0" 
        };
        var url = config.Server+`/basic/service/list`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("setServices is> ", response);
                for(var i=0;i<response.length;i++){
                    
                }
                setServices(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onAddNewItemClick = function(){
        setTitle("");
        setServiceId("");
        setServiceIndex(-1);
        setEnName("");
        setTafsilId(0);
        setBasePrice(0);
        setIsActive(true);
        setShortDescription("");
        setLongDescription("");
        setEditFormVisible(true);
    }
    const onRowEditClick = function(p, cInd){
        console.log("service is>", p)
        setServiceId(p.id);
        setServiceIndex(cInd);
        setTitle(p.title);
        setEnName(p.enName);
        setTafsilId(p.tafsilId);
        setBasePrice(p.basePrice);
        setIsActive(p.isActive);
        setShortDescription(p.shortDescription);
        setLongDescription(p.longDescription);
        setEditFormVisible(true);
    }
    const setRowActions = function (row, cInd) {
        return (
        <Row className="justify-content-md-center" style={{}}>
            <Button icon="pi pi-pencil" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowEditClick(row, cInd)} title="ویرایش" />
            <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowDeleteClick(row, cInd)} title="حذف" />
        </Row>
        );
    }
    //=====================================================================================================================================
    //============                  service edit form                  =======================================================================
    //=====================================================================================================================================
    const checkDataEntry = function(){
        if(title.trim().length < 2){
            setErrorMessage("عنوان خدمت را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(tafsilId <= 0){
            setErrorMessage("کد تفضیل خدمت را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(enName.trim().length < 2){
            setErrorMessage("نام انگلیسی خدمت را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(basePrice <= 0){
            setErrorMessage("قیمت خدمت را مشخص کنید");
            setErorVisible(true);
            return false;
        }

        return true;
    }
    const saveItem = function(){
        if(!checkDataEntry()) return;
        var url = config.Server + `/basic/service/save`;
        var params = {
            login:util.getLoginDto(), 
            id:serviceId,
            title:title,
            tafsilId:tafsilId,
            basePrice:basePrice,
            isActive:isActive,
            enName:enName,
            shortDescription:shortDescription,
            longDescription:longDescription,
        };
        setSaving(true);
        console.log("params to save is>", params);
        console.log("url to save is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...services];
                if(serviceIndex == -1){                    
                    ncs.push({...response});                    
                }
                else{
                    ncs[serviceIndex] = {...response};
                }
                setServices(ncs);
                setSaving(false);
                setEditFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{setEditFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    //============                  delete service                  =======================================================================
    //=====================================================================================================================================
    const onRowDeleteClick = function(poduct, cInd){
        setServiceId(poduct.id);
        setTafsilId(poduct.tafsilId);
        setServiceIndex(cInd);
        setConfirmDeleteVisible(true);
    }
    const deleteItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:serviceId};
        var url = config.Server+`/basic/service/delete`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...services];
                ncs.splice(serviceIndex, 1);
                setServices(ncs);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }

    //=====================================================================================================================================

    const onTafsilIdChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setTafsilId(v);
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "enName") setEnName(val);
        else if(name === "shortDescription") setShortDescription(val);
        else if(name === "longDescription") setLongDescription(val);
        else if(name === "title") setTitle(val);
        // else if(name === "nationalId") setNationalId(val);
    }
    const onInputChanged = function(e){
        if(e.value){
            setBasePrice(e.value);
        }
        else{
            setBasePrice(0);
        }
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست خدمت ها..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            
            
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست خدمت ها
            </div>

              <Row style={{}}>
                <Col xs={12} md={3}>
                    <table>
                        <tr>
                            <td style={{padding:"5px"}}><Button label="ثبت خدمت جدید" icon="pi pi-plus" onClick={()=>onAddNewItemClick()} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                        </tr>
                    </table>
                </Col>
              </Row>

              <DataTable value={services} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id">
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="tafsilId" header={"تفضیل"} sortable className="list-cell-text-align"></Column>
                <Column field="title" header={"عنوان خدمت"} sortable className="list-cell-text-align"></Column>
                <Column field="enName" header={"نام لاتین"} sortable className="list-cell-text-align"></Column>
                <Column field="isActive" header={"وضعیت"} body={(row, options) => row.isActive?"فعال":"غیر فعال"} sortable className="list-cell-text-align"></Column>
                <Column field="basePrice" header={"قیمت"} body={(row, options) => util.SeperatePrice(row.basePrice)} sortable className="list-cell-text-align"></Column>
                <Column body={(row, options) => setRowActions(row, options.rowIndex)} exportable={false} style={{ }}></Column>
              </DataTable>

            {
                editFormVisible?
                <Dialog visible={true} style={{ width: '70rem', height:"calc(100vh - 150px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ثبت مشخصات خدمت" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => setEditFormVisible(false)}>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={title} onChange={(e)=>{onInputChange(e, "title")}} id="title" keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="title">عنوان خدمت</label>
                            </FloatLabel>                                                    
                        </Col>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={tafsilId} onChange={(e)=>{onTafsilIdChanged(e.target.value)}} id="tafsilId" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={7} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="tafsilId">کد تفضیل</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={enName} onChange={(e)=>{onInputChange(e, "enName")}} id="enName" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="enName">نام انگلیسی</label>
                            </FloatLabel>                                                    
                        </Col>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <div key={"isActive"} className="flex align-items-center">
                                <Checkbox value={isActive} inputId={"isActive"} onChange={(e)=>setIsActive(e.checked)} checked={isActive} />
                                <label htmlFor={"isActive"} className="ml-2">&nbsp;خدمت برای فروش آماده باشد</label>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputNumber value={basePrice} onChange={(e) => {onInputChanged(e)}} onValueChange={(e) => {onInputChanged(e)}} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center"}} />
                                <label htmlFor="enName">قیمت پایه</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputTextarea value={shortDescription} onChange={(e)=>{onInputChange(e, "shortDescription")}} id="enName" keyfilter="" maxLength={1000} className="p-inputtext-lg" style={{width:"100%", height:"120px", textAlign:"right", direction:"rtl"}} />
                                <label htmlFor="shortDescription">شرح کوتاه</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputTextarea value={longDescription} onChange={(e)=>{onInputChange(e, "longDescription")}} id="enName" keyfilter="" className="p-inputtext-lg" style={{width:"100%", height:"350px", textAlign:"right", direction:"rtl"}} />
                                <label htmlFor="longDescription">شرح کامل</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>

                </Dialog>
                :
                <></>
            }
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
        </>
    )
}